import axios from '@/axios'

const getNumbers = async ({commit}) => {
  const { data } = await axios.get(`/v1/numbers`)
  commit('SET_NUMBERS', data)
}

export default {
  getNumbers
}
